export default "__VITE_ASSET__DQOLPTWz__"